import { Button } from 'component/Button'
import { Modal } from 'component/Modal'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { profileDeleteModal } from 'page/ProfileScreen/ProfileDeleteModal/ProfileDeleteModalStore'
import { controller } from 'store/controller'

export const ProfileDeleteModal = observer(() => {
  const { profile } = profileDeleteModal.it

  const onCancel = useLatestCallback(async () => {
    profileDeleteModal.close()
  })

  const onDelete = useLatestCallback(async () => {
    void controller.deleteProfile(profile)
    profileDeleteModal.close()
  })

  return <Modal onCancel={onCancel}>
    <Typo size={16}>{i18n('DeleteProfileTitle')}</Typo>
    <Vertical gap={8}>
      <Button large text error action={onDelete}>{i18n('DeleteProfile')}</Button>
      <Button large text action={onCancel}>{i18n('Cancel')}</Button>
    </Vertical>
  </Modal>
})
